<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="修改班级时间" v-model="hideShow" width="600" persistent>
			<v-card>
				<v-card-title>
					<span>修改排课时间</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="6">
							<v-menu v-model="updateTime.menuDateFrom" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="updateTime.beginDate" label="开课日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="updateTime.beginDate" @input="updateTime.menuDateFrom=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="6">
							<v-text-field label="排多少次课" v-model="updateTime.recordTimes" type="number" dense outlined></v-text-field>
						</v-col>
					</v-row>
					<v-row dense class="mb-5">
						<v-col cols="12">
							<span>排课时间：</span>
							<v-btn @click="addOneTime" color="primary" small>再添加一个时间</v-btn>
						</v-col>
					</v-row>
					<v-row dense v-for="(item,index) in updateTime.timePlanList" :key="index">
						<v-col cols="3">
							<v-select v-model="item.weekAt" :items="global.weekList" label="周几上课"
								item-text="weekName" item-value="week" outlined dense></v-select>
						</v-col>
						<v-col cols="3">
							<v-menu v-model="item.menuFrom" :close-on-content-click="false" :nudge-right="40"
								 transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="item.timeFrom" label="上课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="item.menuFrom" v-model="item.timeFrom" full-width format="24hr"
									@click:minute="saveUpdateTimeFrom(item.id,item.timeFrom)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="2">
							<v-text-field label="时长(分钟)" type="number" v-model="item.timeMinutes" dense outlined @keyup="calItemTimeTo(item)">
							</v-text-field>
						</v-col>
						<v-col cols="3">
							<v-menu v-model="item.menuTo" :close-on-content-click="false" :nudge-right="40"
								transition="scale-transition" offset-y
								max-width="290px" min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="item.timeTo" label="下课时间"
										prepend-icon="mdi-clock-time-four-outline" dense readonly v-bind="attrs" v-on="on">
									</v-text-field>
								</template>
								<v-time-picker v-if="item.menuTo" v-model="item.timeTo" full-width format="24hr"
									@click:minute="saveUpdateTimeTo(item.id,item.timeTo)"></v-time-picker>
							</v-menu>
						</v-col>
						<v-col cols="1">
							<v-btn @click="updateTime.timePlanList.splice(index,1)" color="error" small>删除</v-btn>
						</v-col>
					</v-row>
					
				</v-card-text>
				<v-card-actions>
					<span style="color:red">注：提交修改将按本页面时间重新生成班级排课记录</span>
					<v-spacer></v-spacer>
					<v-btn @click="cancel" >关闭</v-btn>
					<v-btn @click="submitUpdateTime" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import global from "../config/global"
	export default {
		name:"update-student-price",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classModel:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					
					this.updateTime.classId = this.classModel.id;
					if (this.classModel.timePlanList){
						this.updateTime.timePlanList = [...this.classModel.timePlanList];
					}else{
						this.updateTime.timePlanList = [];
					}
					
					//this.updateTime.beginDate = this.classModel.dateFrom;
					let balance =  parseInt(this.classModel.totalTimes) -  parseInt(this.classModel.approvedTimes)
					this.updateTime.recordTimes = balance.toString();
				}
			}
		},
		data(){
			return {
				global:global,
				updateTime:{
					menuDateFrom:false,
					classId:"",
					beginDate:"",
					recordTimes:"0",
					timePlanList :[]
				},
				hideShow:this.show
			}
		},
		mounted() {
			console.log("update class time mounted");
		},
		methods:{
			calItemTimeTo(item){
				// 选择开始时间 自动计算 结束时间
				console.log("timeFrom:",item.timeFrom);
				console.log("timeMinutes:",item.timeMinutes);
				
				// 必须有开始时间和时长
				if (!item.timeFrom || !item.timeMinutes){
					item.timeTo = "";
					console.log("no timeFrom or minutes");
					return
				}
				
				// 开始时间分割
				let arr = item.timeFrom.split(":");
				if (!arr || arr.length != 2){
					console.log("timeFrom invalid");
					return
				}
				// 构建一个日期 加上分钟数
				var sdate1 = new Date(2027,1,1,parseInt(arr[0]),parseInt(arr[1]),1);
				sdate1.setMinutes (sdate1.getMinutes () + parseInt(item.timeMinutes));
				
				// 新的时间和分钟
				let newHour = sdate1.getHours();
				let newMinutes = sdate1.getMinutes();
				
				// 左侧补齐2位
				const  hh = (Array(2).join(0) + newHour).slice(-2);
				const  mm = (Array(2).join(0) + newMinutes).slice(-2);
				
				var timeTo = hh+":"+mm;
				
				item.timeTo = timeTo;
				console.log("item.timeTo",item.timeTo);
				
			},
			cancel(){
				this.$emit("cancel","");
			},
			saveUpdateTimeFrom(id,v){
				// 保存开始时间
				this.updateTime.timePlanList.forEach((item,index)=>{
					if(item.id === id){
						item.timeFrom = v;
						item.menuFrom = false;
						// 计算结束时间
						this.calItemTimeTo(item);
					}
				});
			},
			saveUpdateTimeTo(id,v){
				// 保存结束时间
				this.updateTime.timePlanList.forEach((item,index)=>{
					if(item.id === id){
						item.timeTo = v;
						item.menuTo = false;
					}
				});
			},
			addOneTime(){
				if(this.updateTime.timePlanList.length>=7){
					this.$noty.error("一周最多可以排7次课");
					return
				}
				let plan = {weekAt:"",timeFrom:"",timeTo:"",timeMinutes:"45",menuFrom:false,menuTo:false};
				this.updateTime.timePlanList.push(plan);
			},
			
			
			submitUpdateTime(){
				console.log("time plan",this.updateTime);
				// 提交修改
				if (!this.updateTime.classId) {
					this.$noty.error('班级ID不能为空');
					return
				}
				if (!this.updateTime.beginDate) {
					this.$noty.error('开始时间不能为空');
					return
				}
				if (!this.updateTime.recordTimes) {
					this.$noty.error('课次数不能为空');
					return
				}
				
				
				// api
				const that = this;
				let url = `/edu/class/time/update`;
				
				// parameters
				
				const updateData = {
					classId:this.updateTime.classId,
					beginDate:this.updateTime.beginDate,
					recordTimes:this.updateTime.recordTimes,
					timePlanList:this.updateTime.timePlanList
				}
				
				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							this.$emit("success","");
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
		}
	}
	
</script>

